import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import NumberFormat from 'react-number-format';

import LabelName from 'components/UI/LabelName/LabelName';
import { RequiredValidation } from 'components/UI/RequiredValidation/RequiredValidation';
import SubText from '../FormComponenets/SubText';

export default function PhoneNumber({
  handleSettingsClick,
  item,
  index,
  isFormBuilder,
  relationFieldName,
  isRelation = false,
  isFromPreview = false,
}) {
  const {
    control,
    formState: { errors },
    setValue,
  } = useFormContext();

  const { subtext, required, label = 'Short Text' } = item || {};
  const name = isRelation ? relationFieldName : item?.field_name || `form_data.${index}.value`;

  return (
    <div className="w-100">
      <LabelName>
        {label}
        {required && <span className="danger-text"> *</span>}
      </LabelName>
      <div className="d-flex align-items-center flex-wrap">
        <Controller
          name={name}
          control={control}
          rules={isFormBuilder ? {} : { required: required ? 'Required Field' : false }}
          render={({ field }) => (
            <NumberFormat
              className="input-shadow w-100 p-2 border-0 number-format p-inputtext"
              placeholder="eg: (123) 456-7890"
              format="(###) ###-####"
              mask="_"
              name="phone"
              keyfilter={'pnum'}
              onValueChange={(e) => {
                field.onChange(e.value);
                if (item?.field_name && !isRelation) {
                  setValue(`form_data.${index}.value`, e.value);
                }
              }}
              value={field.value}
              style={{ pointerEvents: isFormBuilder || isFromPreview ? 'none' : 'auto' }}
              getInputRef={isFormBuilder ? null : field.ref}
            />
          )}
        />
        <SubText {...{ subtext, handleSettingsClick, item, isFormBuilder }} />
      </div>
      <RequiredValidation field={name} errors={errors} />
    </div>
  );
}
